// GENERATED FILE — do not edit by hand.
// Overwritten at build time by scripts/generate-version.js.
export const APP_VERSION = '39fa9fb1a2ef6adb83b49d6602f2e7fe6b552d53';
export const BUILD_NUMBER = '257';
export const BUILD_TIMESTAMP = '2026-10-01T03:45:11.835Z';
